import React from 'react';
import { createRoot } from 'react-dom/client';
import utils from 'utils';
import { Provider } from 'react-redux';
import Authenticated from 'components/Authenticated';
import AuthenticatedFlyout from 'components/AuthenticatedFlyout';
import UnauthenticatedFlyout from 'components/UnauthenticatedFlyout';

/**
 * A public init method must exist to be called from uiManager
 * @param {Object} store The redux store for the site
 * @param {HTMLElement} domEl The dom element related to this module
 */
export default {
  init(store, domEl) {
    if (utils.config.getIsEnableAlamoInsider() && domEl) {
      const insidersLogoSrc = domEl.dataset?.insidersLogo;
      // Disable join from UnauthenticatedFlyout and My Profile and My Trips links from AuthenticatedFlyout AWR-6213
      const disableJoin = domEl.getAttribute('disable-join') === 'true' || false;
      const disableRedirectOnSignIn = domEl.getAttribute('disable-auth-change-redirect') === 'true' || false;
      const root = createRoot(domEl);
      root.render(
        <Provider store={store}>
          <Authenticated options={{ first_name: true, last_name: true }}>
            {({ logged_in, profileData }) =>
              logged_in ? (
                <AuthenticatedFlyout {...profileData} disableNavigation={disableJoin} />
              ) : (
                <UnauthenticatedFlyout
                  insidersLogoSrc={insidersLogoSrc}
                  disableJoin={disableJoin}
                  disableRedirectOnSignIn={disableRedirectOnSignIn}
                />
              )
            }
          </Authenticated>
        </Provider>
      );
    }
  },
};
